__turbopack_context__.v({
  "label": "index-module-scss-module__-YUbrq__label",
  "radio-group": "index-module-scss-module__-YUbrq__radio-group",
});
